// extracted by mini-css-extract-plugin
module.exports = {"backgroundGray":"_1igRP-","productsSection":"_1YN6BM"};